module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAcklEQVR4Ae3WwQmAMBBE0W3Bg6LdawuKJRkPmhq+FSxCshKQeeeBfx2LJsLIxk2pm43RfPQkap105mEmwmIeLiJc5iHIdwEF3ncKKOAN4wMKKOAG/xBQQAHdlvaBgwhHw/s+kKiV6M3HxE6mVGZlMpFgD8SltLpYs3DvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Actionbar/baseline_insert_chart_white_24dp.png
// module id = 59
// module chunks = 0